import React from 'react';
import upperFirst from 'lodash-es/upperFirst';

// eslint-disable-next-line rover/no-namespace-import-icons
import * as icons from '@rover/icons';
import { Box } from '@rover/kibble/core';
import IconBlock from '@rover/kibble/patterns/IconBlock/IconBlock';
import type { Attribute } from '@rover/rsdk/src/apiClient/latest/model/attribute';
import { camelizeString } from '@rover/rsdk/src/modules/Network/object-utilities';

import { SitterProfileVersionOptions } from '../../constants';
import type { SitterProfileVersion } from '../../hooks/useRevampProfileContext';
import { isLegacyVersion } from '../../utils/utils';

type Props = {
  dogsPreferencesAttributes: Attribute[];
  sitterProfileVersion?: SitterProfileVersion;
};

const renderIcon = (attr: Attribute): React.ReactNode => {
  const iconMap = {
    'no-females-in-heat': icons.Cancel,
    'accepts-only-one-client': icons.AlertInfo,
  };
  return iconMap[attr.key] || icons[upperFirst(camelizeString(attr.icon))] || icons.Dog;
};

const PetPreferences = ({
  dogsPreferencesAttributes,
  sitterProfileVersion = SitterProfileVersionOptions.LEGACY,
}: Props): JSX.Element => {
  const isLegacy = isLegacyVersion(sitterProfileVersion);
  const spacing = isLegacy ? 'my' : 'py';

  return (
    <Box mt="6x">
      {dogsPreferencesAttributes.map((attribute) => (
        <Box key={attribute.key} {...{ [spacing]: '2x' }}>
          <IconBlock
            title={attribute.text}
            size="200"
            fontWeight="regular"
            iconSize="24"
            icon={renderIcon(attribute)}
          />
        </Box>
      ))}
    </Box>
  );
};

export default PetPreferences;
